import { FILTER_CONFIG } from '@/models/filter/filterConfig';
import { isFilterType } from '@/utils/filter/isFilterType';

/**
 * Resolves the Filter Bar label translation key for a filter key.
 * Supports namespaced keys (e.g. `hcpCharacteristic.ta`) used by component-level filter stores.
 */
export const getFilterTypeLabelKey = (filterKey: string): string | undefined => {
  const filterType = filterKey.split('.').at(-1);
  return filterType && isFilterType(filterType) ? FILTER_CONFIG[filterType].label : undefined;
};
